import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_chevronUp",
  "use": "icon_chevronUp-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 48 48\" id=\"icon_chevronUp\"><path fill=\"currentColor\" d=\"M25.555 11.507l17.801 17.801c.859.859.859 2.25 0 3.11l-2.076 2.075a2.198 2.198 0 01-3.106.004L24 20.39 9.825 34.497a2.198 2.198 0 01-3.105-.004l-2.076-2.076a2.198 2.198 0 010-3.109l17.801-17.801a2.199 2.199 0 013.11 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol